"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.autocompleteAddress = void 0;
const addressMapping = {
    street_number: { key: "streetLine1", type: "long" },
    route: { key: "streetLine1", type: "short" },
    subpremise: { key: "streetLine2", type: "short" },
    sublocality_level_1: { key: "city", type: "long" },
    locality: { key: "city", type: "long" },
    administrative_area_level_1: { key: "state", type: "short" },
    postal_code: { key: "zipCode", type: "short" },
};
/**
 * Reusable autocomplete function for address fields
 *
 * @param field - input field to attach autocomplete to (document.getElementById( *fieldId* ) as HTMLInputElement)
 * @param Autocomplete - google.maps.places.Autocomplete
 * @param handleAddress - callback function that handles the address object
 * @returns void
 */
const autocompleteAddress = (field, Autocomplete, handleAddress) => {
    if (!Autocomplete) {
        return;
    }
    const autocomplete = new Autocomplete(field, {
        componentRestrictions: { country: ["us"] },
        fields: ["address_components", "geometry"],
        types: ["address"],
    });
    autocomplete.addListener("place_changed", () => {
        // TODO: room for optimization on getPlace
        const components = autocomplete.getPlace()
            .address_components;
        if (!components) {
            return;
        }
        const toReturn = {
            streetLine1: "",
            streetLine2: "",
            city: "",
            state: "",
            country: "US",
            zipCode: "",
        };
        components.forEach((c) => {
            const mapping = addressMapping[c.types[0]];
            if (mapping) {
                const value = mapping.type === "short" ? c.short_name : c.long_name;
                // allows us to append route to streetLine1
                if (mapping.key === "streetLine1" && toReturn.streetLine1) {
                    toReturn.streetLine1 += ` ${value}`;
                }
                else {
                    toReturn[mapping.key] = value;
                }
            }
        });
        handleAddress(toReturn);
    });
};
exports.autocompleteAddress = autocompleteAddress;
